import React, { useEffect } from 'react'
import { Layout } from 'antd'
import { connect } from 'react-redux'
import { segmentApi } from '@edulastic/api'
import { TRACK_IDS } from '@edulastic/constants/educationJoyrides'
import NewHeaderSection from './Header/NewHeader'
import {
  getUserContextsLoading,
  getIsIlpDashboardJoyridePending,
  getIsDashboardJoyrideAndSignupFlowCompleted,
  getIsNewDashboardJoyrideAccountEligible,
} from '../ducks'
import NewDashboard from './Showcase/components/NewDashboard'
import NewDashboardJoyride from './NewDashboardJoyride'
import EducationJoyride from '../../src/components/EducationJoyride'
import ProfileReportsJoyride from './ProfileReportsJoyride'
import { DASHBOARD_VISIT_SEGMENT_EVENT } from '../constants'
import {
  allowInstantLessonPackageSelector,
  getUserFeatures,
} from '../../src/selectors/user'

const Dashboard = ({
  userId,
  history,
  isUserContextLoading,
  allowInstantLessonPackage,
  isILPButtonBlacklisted,
  isIlpDashboardJoyridePending,
  isDashboardJoyrideAndSignupFlowCompleted,
  isNewDashboardJoyrideAccountEligible,
}) => {
  const showIlpJoyride = allowInstantLessonPackage && !isILPButtonBlacklisted
  const showProfileReportsJoyride = !isIlpDashboardJoyridePending

  useEffect(() => {
    if (!userId) return
    segmentApi.genericEventTrack(DASHBOARD_VISIT_SEGMENT_EVENT, {
      dashboardVersion: 'new',
    })
  }, [userId])

  if (!userId) {
    return null
  }
  return (
    <Layout>
      <NewHeaderSection history={history} />
      <NewDashboard />
      <NewDashboardJoyride />
      {/* ILP is the highest-priority education joyride, but it still waits for
          the sign-up flow (welcome / select-school / get-started modals) AND the
          dashboard overview tutorial. Class Reports and Curriculum then wait for it.
          It's also suppressed within 48h of registration (ASM-543); blocking via
          legacyBlocked (rather than featureGate) keeps the "aggressive" phase
          intact so it fires normally once the account crosses the window. */}
      <EducationJoyride
        trackId={TRACK_IDS.GENAI_DASHBOARD_ILP}
        featureGate={showIlpJoyride}
        contextsLoading={isUserContextLoading}
        legacyBlocked={
          !isDashboardJoyrideAndSignupFlowCompleted ||
          !isNewDashboardJoyrideAccountEligible
        }
      />
      {/* Class Reports is next in line — hold it back while the ILP joyride is
          still pending so the two never overlap. */}
      {showProfileReportsJoyride ? <ProfileReportsJoyride /> : null}
    </Layout>
  )
}
export default connect((state) => ({
  userId: state?.user?.user?._id,
  isUserContextLoading: getUserContextsLoading(state),
  allowInstantLessonPackage: allowInstantLessonPackageSelector(state),
  isILPButtonBlacklisted: getUserFeatures(state)?.isILPButtonBlacklisted,
  isIlpDashboardJoyridePending: getIsIlpDashboardJoyridePending(state),
  isDashboardJoyrideAndSignupFlowCompleted: getIsDashboardJoyrideAndSignupFlowCompleted(
    state
  ),
  isNewDashboardJoyrideAccountEligible: getIsNewDashboardJoyrideAccountEligible(
    state
  ),
}))(Dashboard)
